import { Modal, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { DatePicker } from 'components/ui';
import { MODAL_SIZES } from 'config/modaSettings';
import { routes } from 'config/routes';
import { useVerificationFormStore } from 'stores/local';

import s from './PublishModal.module.scss';

const PublishModal: React.FC = () => {
  const { t } = useTranslation();
  const store = useVerificationFormStore();

  const navigate = useNavigate();

  const handlePublish = React.useCallback(async () => {
    const { isError } = await store.publish();

    if (!isError) {
      navigate(routes.form.createPath());
    }
  }, [store, navigate]);

  return (
    <Modal
      width={MODAL_SIZES.s}
      onCancel={store.publishModal.modalState.close}
      open={store.publishModal.modalState.opened}
      title={t('verification.publication')}
      cancelText={t('common.cancel')}
      okText={t('common.publish')}
      onOk={handlePublish}
      confirmLoading={store.publishingTable}
      centered
    >
      <div className={s.publishModal__wrapper}>
        <Typography.Text>
          {t('verification.publicationDescription')}{' '}
          <Typography.Text type="secondary">
            {t('verification.optional')}
          </Typography.Text>
        </Typography.Text>
        <DatePicker.RangePicker
          value={store.publishModal.entryRange.value}
          onChange={store.publishModal.entryRange.setValue}
          className={s.publishModal__picker}
        />
      </div>
    </Modal>
  );
};

export default observer(PublishModal);
